import {useMemo} from 'react'
import {useSearchParams} from 'react-router'

import {ShutdownHistoryDetail} from './ShutdownHistoryDetail'

import {useShutdowns} from '@refra/modules/common/providers'
import type {Shutdown} from '@refra/modules/common/types'

interface ShutdownHistoryCardBodyProps {
  textFilter: string
}

export const ShutdownHistoryCardBody = ({textFilter}: ShutdownHistoryCardBodyProps) => {
  const {activeShutdowns, selectedShutdown, setSelectedShutdown} = useShutdowns()
  const [_, setSearchParams] = useSearchParams()

  const filteredShutdowns = useMemo<Shutdown[]>(() => {
    if (!activeShutdowns) return []

    if (textFilter) {
      return activeShutdowns.filter((shutdown) => {
        const fieldsToFilter = [shutdown.name, shutdown.interventionDate, shutdown.feedingDate]
        return fieldsToFilter.some((field) =>
          field ? field.toLowerCase().includes(textFilter.trim().toLowerCase()) : false
        )
      })
    }

    return activeShutdowns
  }, [activeShutdowns, textFilter])

  const toggleShutdown = (shutdown: Shutdown) => {
    setSelectedShutdown(selectedShutdown?.id === shutdown.id ? undefined : shutdown)
    setSearchParams((params) => {
      const isToggled = selectedShutdown?.id === shutdown.id
      if (isToggled) {
        params.delete('shutdownId')
      } else {
        params.set('shutdownId', shutdown.id.toString())
      }
      return params
    })
  }

  return (
    <>
      {filteredShutdowns.map((shutdown) => (
        <ShutdownHistoryDetail
          key={`shutdown_history_shutdown-${shutdown.id}`}
          shutdown={shutdown}
          isSelected={selectedShutdown?.id === shutdown.id}
          onClick={() => toggleShutdown(shutdown)}
        />
      ))}
    </>
  )
}
